import React from 'react'

import { FormattedMessage } from 'gatsby-plugin-react-intl'
import scrollTo from 'gatsby-plugin-smoothscroll'

import * as S from './styled'

function Button({ typeButton, as, to, href, display, goTo, borderColor, colorText, children }) {
  const ButtonType = {
    outline: <S.ButtonOutline to={to}>{children}</S.ButtonOutline>,
    cta: (
      <S.ButtonDefault as={'a'} href={href} target="_blank" rel="noreferrer">
        {children}
      </S.ButtonDefault>
    ),
    'scroll-to': (
      <S.ButtonDefault as={'button'} onClick={() => scrollTo(goTo)}>
        {children}
      </S.ButtonDefault>
    ),
    white: (
      <S.WhiteButton as={as} to={to} href={href} target="_blank" rel="noreferrer">
        {children}
      </S.WhiteButton>
    ),
    'outline-white': (
      <S.OutlineWhiteButton as={as} to={to} href={href} target="_blank" rel="noreferrer">
        {children}
      </S.OutlineWhiteButton>
    ),
    'start-now': (
      <S.ButtonDefault to="/contact/" style={{ display: display }} id="start-now">
        {<FormattedMessage id="buttons.start_now" />}
      </S.ButtonDefault>
    ),
    'start-now-home': (
      <S.ButtonDefault to="/agende-uma-demo/">{<FormattedMessage id="buttons.start_now" />}</S.ButtonDefault>
    ),
    'start-here-home': (
      <S.ButtonDefault to="/agende-uma-demo/">{<FormattedMessage id="buttons.start_here" />}</S.ButtonDefault>
    ),
    'start-for-free': (
      <S.ButtonDefault as={'button'} onClick={() => scrollTo('#start')}>
        {<FormattedMessage id="freemium.hero.get_free" />}
      </S.ButtonDefault>
    ),
    'no-scape': (
      <S.ButtonContact as={'button'} onClick={() => scrollTo('#start')}>
        {children}
      </S.ButtonContact>
    ),
    'cta-no-scape': (
      <S.ButtonDefault as={'button'} onClick={() => scrollTo('#start')}>
        {children}
      </S.ButtonDefault>
    ),
    'outline-color': (
      <S.OutlineColorButton
        borderColor={borderColor}
        colorText={colorText}
        as={as}
        to={to}
        href={href}
        target="_blank"
        rel="noreferrer"
      >
        {children}
      </S.OutlineColorButton>
    ),
    default: <S.ButtonDefault to={to}>{children}</S.ButtonDefault>
  }

  return ButtonType[typeButton] || ButtonType['default']
}

export default Button
